import React from "react";
import { Outlet } from "react-router-dom";

const ToolsRoot = () => {
  return <Outlet />;
};

export default ToolsRoot;
